/* Cosmic Escentuals — app-feel layer.
   1) Scroll-reveal: sections and card grids rise softly into view.
   2) NLSheet: bottom-sheet mini-cart confirmation used by quick-add buttons.
   Both respect prefers-reduced-motion and degrade to nothing without JS. */
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveal ---------- */
  if (!reduced && 'IntersectionObserver' in window) {
    var sections = document.querySelectorAll('main [id^="shopify-section-"]');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '2000px 0px -8% 0px', threshold: 0.05 });

    Array.prototype.forEach.call(sections, function (sec, i) {
      var rect = sec.getBoundingClientRect();
      if (rect.top > window.innerHeight * 0.9) {
        sec.classList.add('nl-reveal');
        io.observe(sec);
      }
      // stagger cards inside grids/rows
      Array.prototype.forEach.call(sec.querySelectorAll('[class*="__grid"] > *, [class*="__row"] > *'), function (card, ci) {
        if (ci < 12) card.style.transitionDelay = Math.min(ci * 45, 360) + 'ms';
      });
    });
  }

  /* ---------- bottom-sheet mini-cart ---------- */
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  var sheet, backdrop;
  function build() {
    if (sheet) return;
    backdrop = document.createElement('div');
    backdrop.className = 'nl-sheet__backdrop';
    sheet = document.createElement('div');
    sheet.className = 'nl-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', 'Added to bag');
    sheet.innerHTML =
      '<div class="nl-sheet__grip" aria-hidden="true"></div>' +
      '<div class="nl-sheet__row">' +
        '<div>' +
          '<div class="nl-sheet__title">Added to your bag &#10003;</div>' +
          '<div class="nl-sheet__meta" data-nl-sheet-meta></div>' +
        '</div>' +
      '</div>' +
      '<div class="nl-sheet__actions">' +
        '<a class="nl-sheet__view" href="/cart">View Bag</a>' +
        '<button type="button" class="nl-sheet__stay" data-nl-sheet-close>Keep Shopping</button>' +
      '</div>';
    document.body.appendChild(backdrop);
    document.body.appendChild(sheet);
    backdrop.addEventListener('click', close);
    sheet.querySelector('[data-nl-sheet-close]').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  function open(cart) {
    build();
    function fill(c) {
      var items = c.item_count === 1 ? '1 item' : c.item_count + ' items';
      sheet.querySelector('[data-nl-sheet-meta]').textContent = items + ' · Subtotal ' + money(c.total_price);
      requestAnimationFrame(function () {
        backdrop.classList.add('is-open');
        sheet.classList.add('is-open');
      });
      sheet.querySelector('[data-nl-sheet-close]').focus({ preventScroll: true });
    }
    if (cart && typeof cart.item_count !== 'undefined') { fill(cart); }
    else {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(fill).catch(function () {});
    }
  }

  function close() {
    if (!sheet) return;
    backdrop.classList.remove('is-open');
    sheet.classList.remove('is-open');
  }


  /* ---------- auto-hiding mobile header ---------- */
  (function () {
    var mq = window.matchMedia('(max-width: 749px)');
    var lastY = window.scrollY;
    var ticking = false;
    function onScroll() {
      if (!mq.matches) { document.documentElement.classList.remove('nl-hd-hide'); return; }
      var y = window.scrollY;
      if (y > lastY + 6 && y > 90) {
        document.documentElement.classList.add('nl-hd-hide');
      } else if (y < lastY - 6 || y <= 90) {
        document.documentElement.classList.remove('nl-hd-hide');
      }
      lastY = y;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () { onScroll(); ticking = false; });
      }
    }, { passive: true });
  })();

  /* ---------- fly-to-bag ---------- */
  if (!reduced) {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.nl [class*="__add"]');
      if (!btn || btn.closest('.nl-sheet')) return;
      var card = btn.closest('[class*="__card"], [class*="__prod"], [class*="__item"], [data-nl-pd], .nl-pd');
      var img = card && card.querySelector('img');
      if (!img) return;
      var target = null;
      var tabBag = document.querySelector('.nl-tabbar__bagwrap');
      if (tabBag && tabBag.offsetParent) target = tabBag;
      if (!target) {
        var count = document.querySelector('header .nl-cart-count, .nl-hd .nl-cart-count');
        if (count) target = count.parentElement;
      }
      if (!target) return;
      var from = img.getBoundingClientRect();
      var to = target.getBoundingClientRect();
      if (!from.width || !to.width) return;
      var clone = img.cloneNode();
      clone.className = 'nl-fly';
      clone.style.cssText = 'position:fixed;z-index:900;left:' + from.left + 'px;top:' + from.top + 'px;width:' + from.width + 'px;height:' + from.height + 'px;object-fit:contain;pointer-events:none;border-radius:8px;transition:transform 0.65s cubic-bezier(0.4, 0, 0.6, 1), opacity 0.65s ease;';
      document.body.appendChild(clone);
      var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
      var dy = (to.top + to.height / 2) - (from.top + from.height / 2);
      requestAnimationFrame(function () {
        clone.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.08)';
        clone.style.opacity = '0.35';
      });
      setTimeout(function () {
        clone.remove();
        Array.prototype.forEach.call(document.querySelectorAll('.nl-cart-count'), function (el) {
          el.classList.remove('nl-badge-pulse');
          void el.offsetWidth;
          el.classList.add('nl-badge-pulse');
        });
      }, 680);
    });
  }

  window.NLSheet = { open: open, close: close };
})();
